import { IStuLop } from "../../../model/respone/category/IStuLop";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eStuLopNamHocActionsObj = {
  CHANGE_NAM_HOC: "",
  LOAD_START: "",
  LOAD_SUCCESS: {} as IStuLop[],
  LOAD_ERRR: "",
};
export const eStuLopNamHocActionIds = generateActionTypeIds(
  eStuLopNamHocActionsObj,
  "LOP_NAM_HOC"
);
export type IStuLopNamHocActionTypes = IGenericActionType<
  typeof eStuLopNamHocActionsObj,
  "LOP_NAM_HOC"
>;
